import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mn-blue-element" }

import { EffortSummary, SunriseReportRmodel } from '@/app.context/workspace/persons/sunrise.rmodel';
import EffortStatusSubcomponent from './status/EffortStatusSubcomponent.vue'
import { minuteCalc } from "@/logic/_infra/time";
import TodoTitleComponent from '@/components/Workspaces/todos/_spec/TodoTitleComponent.vue';
import { TicketRmodel } from '@/app.context/workspace/ticket.rmodel';
import sys from '@/sys';
import { effortQueueOperationCss, queueUpdateCss, effortStatsResolutionCss } from '@/controllers/workspaces/persons/effort.controller'

import EffortTitleComponent from '@/app/workspace/persons/EffortTitleComponent.vue'

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EffortStatusComponent',
  props: {
    status: {},
    showOverlaps: { type: Boolean },
    log: {}
  },
  setup(__props: any) {

const props = __props








return (_ctx: any,_cache: any) => {
  return (_ctx.status != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(EffortStatusSubcomponent, { status: _ctx.status }, null, 8, ["status"]),
        (_ctx.log != undefined)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.log, (s) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: s.period.timepoint
              }, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(s.period.timepoint.toDateString()), 1),
                _createVNode(EffortStatusSubcomponent, {
                  status: s.summary
                }, null, 8, ["status"])
              ], 64))
            }), 128))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})